// ============================================
// AMENITIES SECTION - Shrileela Beach Resort
// ============================================

import {amenities} from '../../data/shreeData'


const AmenitiesSection = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Jost:wght@300;400;500;600&display=swap');

        .amenities-section {
          padding: 100px 24px;
          background: #f8faf7;
          font-family: 'Jost', sans-serif;
        }
        .amenities-inner {
          max-width: 1100px;
          margin: 0 auto;
        }
        .amenities-header {
          text-align: center;
          margin-bottom: 64px;
        }
        .section-eyebrow {
          display: inline-block;
          background: #e8f0e8;
          color: #3d5a3e;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
          padding: 6px 18px;
          border-radius: 40px;
          margin-bottom: 20px;
        }
        .section-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(32px, 5vw, 52px);
          font-weight: 700;
          color: #1a2b1a;
          margin: 0 0 16px;
          line-height: 1.15;
        }
        .section-subtitle {
          font-size: 17px;
          color: #666;
          font-weight: 300;
          max-width: 520px;
          margin: 0 auto;
          line-height: 1.7;
        }

        .amenities-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 8px;
        }
        .amenity-card {
          background: #fff;
          border-radius: 16px;
          padding: 32px 20px;
          text-align: center;
          border: 1.5px solid transparent;
          transition: all 0.35s ease;
          cursor: default;
        }
        .amenity-card:hover {
          border-color: #3d5a3e;
          transform: translateY(-4px);
          box-shadow: 0 12px 40px rgba(61,90,62,0.1);
        }
        .amenity-icon {
          font-size: 38px;
          margin-bottom: 16px;
          display: block;
          transition: transform 0.3s;
        }
        .amenity-card:hover .amenity-icon { transform: scale(1.15); }
        .amenity-name {
          font-weight: 600;
          font-size: 14px;
          color: #1a2b1a;
          margin-bottom: 8px;
          letter-spacing: 0.3px;
        }
        .amenity-desc {
          font-size: 12px;
          color: #888;
          line-height: 1.5;
          font-weight: 300;
        }

        @media (max-width: 900px) { .amenities-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 500px) { .amenities-grid { grid-template-columns: 1fr 1fr; gap: 6px; } .amenity-card { padding: 24px 14px; } }
      `}</style>

      <section className="amenities-section">
        <div className="amenities-inner">
          <div className="amenities-header">
            <span className="section-eyebrow">Resort Facilities</span>
            <h2 className="section-title">Everything You Need</h2>
            <p className="section-subtitle">All the comforts for a perfect beach getaway at Murud</p>
          </div>

          <div className="amenities-grid">
            {amenities.map((item, i) => (
              <div key={i} className="amenity-card">
                <span className="amenity-icon">{item.icon}</span>
                <div className="amenity-name">{item.name}</div>
                <div className="amenity-desc">{item.description}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AmenitiesSection;